/**
 * generates display name for hoc components
 *
 * @param {String} wrapperName
 * @param {Component} WrappedComponent
 * @return {String} wrapped display name
 */
export default function wrappedDisplayName(wrapperName, WrappedComponent) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  return `${wrapperName}(${displayName})`
}
